var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#007ab9","d":"M46.5 93C72.181 93 93 72.181 93 46.5S72.181 0 46.5 0 0 20.819 0 46.5 20.819 93 46.5 93z"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#f1f2f2","d":"M21.663 70h11.154V36.262H21.663zM21 25.828c0 3.24 2.423 5.83 6.162 5.83h.072c3.889 0 6.306-2.59 6.306-5.83-.074-3.31-2.417-5.828-6.232-5.828C23.495 20 21 22.519 21 25.828zm52 24.825c0-10.361-5.499-15.183-12.833-15.183-5.923 0-8.565 3.28-10.047 5.573v.11h-.074c.02-.035.052-.072.074-.11v-4.78H38.97c.15 3.164 0 33.736 0 33.736h11.15V51.157c0-1.011.075-2.013.368-2.734.808-2.018 2.638-4.101 5.719-4.101 4.036 0 5.645 3.095 5.645 7.627V70H73z"}))])));
}

Linkedin.defaultProps = {"width":"93","height":"93","viewBox":"0 0 93 93"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
